/**
 * Environment constant. Will be true if build was 'dist'
 *
 * @type {boolean}
 */
export const isProduction = process.env.NODE_ENV === 'production';

/**
 * Regex to be used against path parameters, allow only word characters and '-'
 *
 * @type {string}
 */
export const regexPathWord = '[\\w-]+';
export const regexReplacePathWord = '[^\\w]+';

export const regexEmail = /^[A-Z0-9._%+-]+@[A-Z0-9](?!.*\.{2})[A-Z0-9.-]*\.[A-Z]{2,20}$/i;
export const regexURL = /[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_+.,!~#?&//=]*)/gi;

export const siteMaxWidth = '1280px';

// App/Play store links
export const pclnPlayStoreLink = `https://www.priceline.com/r/app/`;
export const pclnAppStoreLink = `https://offers.priceline.com/lrapp/`;

export const pclnExpressDealsLink = `https://www.priceline.com/hotels/?modal=express-deals`;

export const pclnPrivacyPolicyLink = `https://www.priceline.com/static-pages/privacy-policy.html`;

export const hotelsPerPage = 50;
export const reviewsPerReviewsPage = 20;
export const reviewsPerHotelPage = 3;
export const nearbyQualifier = 15;
export const GATrackingID = 'UA-2975581-1';

// DATES
export const DATE_FORMAT = 'MM/DD/YYYY';
export const MAX_CALENDAR_DAYS = 329;

/* Amenity icon mapping */
export const AmenityIcons = {
    FINTRNT: 'wifi',
    SPOOL: 'pool',
    CASINO: 'casino',
    PETALLOW: 'pets',
    FBRKFST: 'breakfast'
};

export const CountriesRequiringThe = [
    'Bahamas',
    'Congo',
    'Central African Republic',
    'Czech Republic',
    'Dem Rep of the Congo (Zaire)',
    'Dominican Republic',
    'Falkland Islands (Islas Malvinas',
    'Faroe Islands',
    'Federated States Of Micronesia',
    'French Southern and Antarctic Lands',
    'Gaza Strip',
    'Ivory Coast',
    'Maldives',
    'Marshall Islands',
    'Netherlands',
    'Republic of Korea',
    'Philippines',
    'Sao Tome and Principe',
    'United Arab Emirates',
    'United Kingdom',
    'United States',
    'Western Sahara'
];
/* eslint-disable line-comment-position, no-inline-comments */
export const AdministrativeDivisions = {
    CA: 'provinces', // Canada
    US: 'states', // USA
    DE: 'states', // Germany
    AU: 'states and Territories', // Australia
    GB: 'counties', // United Kingdom
    FR: 'regions', // France
    IT: 'regions', // Italy
    MX: 'states', // Mexico
    NL: 'provinces', // Netherlands
    ES: 'autonomies', // Spain
    AE: 'emirates', // UAE
    HK: 'districts', // Hong Kong
    TH: 'provinces', // Thailand
    JP: 'prefectures', // Japan
    CN: 'provinces' // China
};
/* eslint-enable line-comment-position, no-inline-comments */
export const attributeBlacklist = [
    'color',
    'mx',
    'my',
    'mt',
    'mr',
    'mb',
    'ml',
    'px',
    'py',
    'pt',
    'pr',
    'pb',
    'pl',
    'font-size',
    'font-weight',
    'theme'
];

export const euCountryCodes = [
    'AL',
    'AD',
    'AM',
    'AT',
    'BY',
    'BE',
    'BA',
    'BG',
    'CH',
    'CY',
    'CZ',
    'DE',
    'DK',
    'EE',
    'ES',
    'FO',
    'FI',
    'FR',
    'GB',
    'GE',
    'GI',
    'GR',
    'HU',
    'HR',
    'IE',
    'IS',
    'IT',
    'LT',
    'LU',
    'LV',
    'MC',
    'MK',
    'MT',
    'NO',
    'NL',
    'PO',
    'PT',
    'RO',
    'RU',
    'SE',
    'SI',
    'SK',
    'SM',
    'TR',
    'UA',
    'UK',
    'VA'
];
